(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    

(() => {

  const initWaansyaUpsell = () => {

    document.querySelectorAll('[data-waansya-upsell]').forEach((root) => {

      if (root.dataset.upsellReady === 'true') return;



      const track = root.querySelector('[data-upsell-track]');

      const prev = root.querySelector('[data-upsell-prev]');

      const next = root.querySelector('[data-upsell-next]');

      if (!track || !prev || !next) return;



      const cards = Array.from(track.querySelectorAll('.waansya-upsell__card'));

      if (cards.length < 3) return;



      const originalCount = Math.floor(cards.length / 3);

      if (!originalCount) return;



      root.dataset.upsellReady = 'true';



      const step = () => {

        const card = track.querySelector('.waansya-upsell__card');

        if (!card) return track.clientWidth * 0.5;

        const styles = getComputedStyle(track);

        const gap = parseFloat(styles.columnGap || styles.gap || 0);

        return card.getBoundingClientRect().width + gap;

      };



      const setWidth = () => step() * originalCount;



      const jumpWithoutAnimation = (left) => {

        const previousBehavior = track.style.scrollBehavior;

        const previousSnap = track.style.scrollSnapType;



        track.style.scrollBehavior = 'auto';

        track.style.scrollSnapType = 'none';

        track.scrollLeft = left;



        track.getBoundingClientRect();



        requestAnimationFrame(() => {

          track.style.scrollBehavior = previousBehavior;

          track.style.scrollSnapType = previousSnap;

        });

      };



      const normalize = () => {

        const width = setWidth();

        if (!width) return;



        if (track.scrollLeft < width * 0.5) {

          jumpWithoutAnimation(track.scrollLeft + width);

        } else if (track.scrollLeft > width * 1.5) {

          jumpWithoutAnimation(track.scrollLeft - width);

        }

      };



      let settleTimer;



      const onScroll = () => {

        window.clearTimeout(settleTimer);

        settleTimer = window.setTimeout(normalize, 140);

      };



      prev.addEventListener('click', () => {

        track.scrollBy({ left: -step(), behavior: 'smooth' });

      });



      next.addEventListener('click', () => {

        track.scrollBy({ left: step(), behavior: 'smooth' });

      });



      track.addEventListener('scroll', onScroll, { passive: true });



      requestAnimationFrame(() => {

        jumpWithoutAnimation(setWidth());

        prev.disabled = false;

        next.disabled = false;

      });

    });

  };



  initWaansyaUpsell();

  document.addEventListener('shopify:section:load', initWaansyaUpsell);

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
